import { InfiniteData } from "@tanstack/react-query";

import { PaginatedData } from "@/types/InfiniteQuery.type";

/**
 * Flattens the `pages` array returned by useInfiniteQuery into a single array.
 */
export const getFlatPaginatedData = <T>(data?: InfiniteData<PaginatedData<T>, unknown>): T[] =>
  data?.pages.flatMap((page) => page.data) ?? [];

/**
 * Returns the total number of results from the first page of the paginated data.
 */
export const getTotalResults = <T>(data: InfiniteData<PaginatedData<T>, unknown> | undefined): number =>
  data?.pages?.[0]?.info?.items_total || 0;
